var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSequence = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 20c-.082 0-.164-.014-.242-.04L.508 13.21c-.284-.098-.482-.354-.506-.653-.022-.299.135-.583.4-.722l22.5-11.75c.251-.129.554-.109.782.054.23.164.349.442.308.722l-2.75 18.5c-.033.22-.162.414-.353.53-.118.072-.253.109-.389.109zM2.646 12.355l17.244 5.894 2.401-16.152z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 23c-.078 0-.157-.012-.233-.037-.309-.102-.517-.389-.517-.713V15.5c0-.189.072-.373.201-.512L22.701.238c.282-.304.759-.319 1.061-.037.303.282.319.757.037 1.061L10.25 15.795v4.168l2.503-3.407c.245-.332.715-.406 1.049-.16.334.245.405.715.16 1.049l-3.857 5.25C9.96 22.89 9.734 23 9.5 23z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSequence, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sequence.d9697cdc.svg";
export { ForwardRef as ReactComponent };